export default __webpack_public_path__ + "static/media/Sample.ad62b122.csv";